var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlternateCamping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.3 2.8 9 1l-1.8.4C2.4 2.7-1 7-1 12c0 6.1 4.9 11 11 11 5 0 9.3-3.4 10.6-8.2L21 13l-1.8.7c-.6.2-1.3.3-2.2.3-4.9 0-9-4.1-9-9 0-.9.1-1.6.3-2.2M6 3.9V5c0 6.1 4.9 11 11 11h1.1l-.1.1C16.5 19 13.5 21 10 21c-4.9 0-9-4.1-9-9 0-3.5 2-6.5 4.9-8zM15 0v4h-2V0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 1v2h-4V1zM21 6v4h-2V6z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M22 7v2h-4V7z"
})));
export default SvgAlternateCamping;